<template>
    <div class="vendor flex row center no-overflow">
        <div class="ven-content-item ven-img-wrap">
            <img class="mobile-img" :src="require('../../assets/Mobile/Mobile_About_Us/V_IMG.png')" alt="Private Customer">
        </div>
        <div class="ven-content-item ven-content-wrap" style="text-align: left;">
            <h1 class="ven-title">Vendor</h1>
            <p class="ven-text"><strong>Streamline of business</strong> - Open up your business to new customers as event requests will be sent to your device</p>
            <p class="ven-text"><strong>Instant marketing and improved branding</strong> - Vendors now have the opportunity to say they have worked with high profile clients, thus increasing there marketing capabilities and empowering their brand</p>
            <p class="ven-text"><strong>Increasing your bottom line</strong> - Vendors will see the amount of requests boom as events will constantly be scheduled.</p>
        </div>
        <div class="ven-content-item ven-img-wrap">
            <img class="md-container" :src="require('../../assets/Desktop/About_Us/ven_img.png')" alt="Vendor Image">
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .vendor {
            height: 1000px !important;
            flex-direction: column !important;
        }

        .ven-text {
            width: 80vw !important;
        }

        .mobile-img {
            height: auto !important;
            width: 90vw !important;
            display: block !important;
            margin: auto !important;
        }
    }

    .mobile-img {
        display: none;
    }

    .vendor {
        height: 770px;
    }

    .ven-title {
        color: #B01C1E;
        font-family: Trirong;
        font-size: 32px;
    }

    .ven-text {
        width: 546px;
        color: #333333;
        font-family: Trirong;
        font-size: 16px;
        letter-spacing: 1px;
    }

    .ven-img-wrap {
        margin: 7% 0 0 0;
    }

    .ven-content-wrap {
        margin: 11% 5% 0 11.5%;
    }
</style>



// WEBPACK FOOTER //
// src/components/about/Vendor.vue